import Joi from "joi";
import queryString from "query-string";
import {anlagenartIdToObj} from "../consts/anlagenart";
import {ABWASSERBEHANDLUNG, anlagentypIdToObj, ENTLASTUNG, KANALNETZ} from "../consts/anlagentyp";
import {KOMMUNAL} from "../consts/betriebstyp";
import {FACHOBJEKTSTATUS_GEPLANT} from "../consts/fachobjektstatus";
import routes from "../consts/routes.json";
import {optionalArray, optionalBool, requiredObject, requiredString, requiredWerteListeObjekt} from "../utils/Validator";
import {createLageSchema} from "./Lage";

export const createInitialAnlage = (betriebstypId, search) => {
    const {typ: possibleTyp, art: possibleArt} = queryString.parse(search);
    let typ = {id: "", value: ""};
    if (possibleTyp) {
        typ = anlagentypIdToObj(possibleTyp);
    }
    let art = {id: "", value: ""};
    if (possibleArt) {
        art = anlagenartIdToObj(possibleArt);
    }

    const initialStatus = {id: FACHOBJEKTSTATUS_GEPLANT, value: "geplant"}
    const objectToSet = {
        anlagenart: null,
        anlagentyp: null,
        anlagenId: null,
        anlagensystem: null,
        anlagenstatus: initialStatus,
        aufnahme: null,
        auslegungUndBelastungsDaten: [],
        behoerdenkennung: "RLP",
        bezeichnung: "",
        indirekteinleiter: false,
        lage: {
            hochwert: "",
            rechtswert: "",
        },
        planungen: [],
        foerderungen: [],
        bauwerke: [],
        selbstueberwachungspflicht: false,
        zustaendigeBearbeiter: [],
        zustaendigePersonen: [],
        kontakte: [],
        drosselablauf: null
    };
    objectToSet.anlagentyp = typ;
    if (art.id) {
        objectToSet.anlagenart = art;
    }
    objectToSet.indirekteinleiter = typ.id === ENTLASTUNG || typ.id === KANALNETZ;
    objectToSet.zustaendigeBearbeiter = [];
    if (
        betriebstypId === KOMMUNAL &&
        objectToSet.anlagenart &&
        objectToSet.anlagenart.id === ABWASSERBEHANDLUNG &&
        !objectToSet.indirekteinleiter
    ) {
        objectToSet.entsorgungsraum = {bezugsdatum: null, bezugsparameter: null, entsorgungsraeume: []};
    }
    return objectToSet;
};

export const createAnlageSchema = (betriebstypId, anlage) => {
    if (anlage?.anlagentyp?.id === ENTLASTUNG) {
        return createAnlageWithEntlastungSchema();
    }

    if (anlage?.anlagentyp?.id === KANALNETZ) {
        return {
            ...createInitialAnlageSchema(),
            ...createAbwasserbeseitigungspflichtigeSchema()
        };
    }

    return createAnlageWithLageSchema();
};

export const createInitialAnlageSchema = () => {
    return {
        bezeichnung: requiredString(),
        kontakte: optionalArray(),
        indirekteinleiter: optionalBool(),
        aufnahme: Joi.when("indirekteinleiter", {is: true, then: requiredObject()}),
        zustaendigeBearbeiter: optionalArray(),
        zustaendigePersonen: optionalArray(),
    };
};

export const createAnlageWithLageSchema = () => {
    return {
        ...createInitialAnlageSchema(),
        ...createAbwasserbeseitigungspflichtigeSchema(),
        lage: createLageSchema(),
    };
};

export const createAnlageWithEntlastungSchema = () => {
    return {
        ...createInitialAnlageSchema(),
        lage: createLageSchema(),
        entlastungssystem: requiredWerteListeObjekt(),
        entlastungstyp: requiredWerteListeObjekt(),
        wasserbuchnummer: Joi.string().regex(/^[S,N+][0-9]*$/).max(9).messages({"string.max": "Max. 9 Zeichen erlaubt", "string.pattern.base": "Wasserbuchnummer ungültig"}),
        flur: Joi.string().allow(null, "").max(5).messages({"string.max": "Max. 5 Zeichen erlaubt"}),
        flurstueck: Joi.string().allow(null, "").max(10).messages({"string.max": "Max. 10 Zeichen erlaubt"}),
        gemarkung: Joi.string().allow(null, "").max(50).messages({"string.max": "Max. 50 Zeichen erlaubt"})
    };
};

export const createAbwasserbeseitigungspflichtigeSchema = () => {
    return {
        abwasserbeseitigungspflichtige: Joi.when("indirekteinleiter", {
            is: false, then: Joi.array()
                .required()
                .min(1)
                .messages({
                    "any.required": "Es muss ein Abwasserbeseitigungspflichtiger ausgewählt werden",
                    "array.min": "Es muss ein Abwasserbeseitigungspflichtiger ausgewählt werden"
                })
        }),
    };
};

export function calculateAnlagenLink(anlage, modus = "modus=l") {
    let pfad = `${routes.BETRIEBSAKTE_RAW}/${anlage.betrieb.id}`;
    if (anlage?.anlagentyp.id === KANALNETZ) {
        pfad = `${pfad}/${anlage?.aufnahme.id}/${anlage?.anlagentyp?.id?.toLowerCase()}`;
    }
    else if (anlage?.anlagentyp.id === ENTLASTUNG) {
        pfad = `${pfad}/entlastung`;
    }
    pfad = `${pfad}/${anlage.id}/anlagendaten?${modus}`;
    return pfad;
}

export function calculateEntlastungsAnlagenLink(anlage, modus = "modus=l") {
    return `${routes.BETRIEBSAKTE_RAW}/${anlage.betrieb.id}/${anlage?.anlagentyp?.id?.toLowerCase()}/${anlage.id}/anlagendaten?${modus}`;
}
